import React, { useRef, useState } from 'react';
import { LexicalComposer } from '@lexical/react/LexicalComposer';
import { RichTextPlugin } from '@lexical/react/LexicalRichTextPlugin';
import { ContentEditable } from '@lexical/react/LexicalContentEditable';
import { HistoryPlugin } from '@lexical/react/LexicalHistoryPlugin';
import { $generateHtmlFromNodes } from '@lexical/html';
import { $getRoot } from 'lexical';
import html2pdf from 'html2pdf.js';
import { saveAs } from 'file-saver';
import { Document, Packer, Paragraph } from 'docx';
import '../../css/App.css';

import { ToolbarPlugin } from './ToolbarPlugin'; // Ensure this exists
import  SavePlugin from './SavePlugin'; // Custom plugin to track changes

const theme = {
  paragraph: 'editor-paragraph',
  text: {
    bold: 'editor-bold',
    italic: 'editor-italic',
    underline: 'editor-underline',
  },
};

const editorConfig = {
  namespace: 'MyEditor',
  theme,
  onError: (error) => console.error(error),
  nodes: [],
};

const RichTextEditor = () => {
  const htmlContentRef = useRef('');

  const handleSave = async () => {
    try {
      const html = htmlContentRef.current;
    //  console.log('Saving HTML:', html);
      // await axios.post('http://localhost:3002/save-content.php', { content: html });
      alert('✅ Content ready for save!');
    } catch (err) {
      console.error(err);
      alert('❌ Save failed.');
    }
  };

 

const handleExportPDF = () => {
  const element = document.createElement('div');
  element.innerHTML = htmlContentRef.current;

  const opt = {
    margin:       [10, 10, 10, 10],
    filename:     'document.pdf',
    image:        { type: 'jpeg', quality: 0.98 },
    html2canvas:  {
      scale: 2,
      useCORS: true
    },
    jsPDF: {
      unit: 'mm',
      format: 'a4',
      orientation: 'portrait'
    },
    pagebreak: {
      mode: ['css', 'legacy'], // honor CSS rules
      avoid: ['.avoid-break', 'p', 'span']
    }
  };

  html2pdf().set(opt).from(element).save();
};





  const handleExportDoc = async () => {
    const html = htmlContentRef.current;
    const plainText = html.replace(/<[^>]+>/g, '').split(/\r?\n/);
    const doc = new Document({
      sections: [
        {
          children: plainText.map(line => new Paragraph(line)),
        },
      ],
    });
    const blob = await Packer.toBlob(doc);
    saveAs(blob, 'document.docx');
  };









  return (
    <LexicalComposer initialConfig={editorConfig}>
      <div className="editor-container">
        <ToolbarPlugin />
        <RichTextPlugin
          contentEditable={<ContentEditable className="editor-input" />}
          placeholder={<div className="editor-placeholder">Type here…</div>}
        />
        <HistoryPlugin />
        <SavePlugin htmlContentRef={htmlContentRef} />

        <div style={{ marginTop: 20, display: 'flex', gap: 10 }}>
          <button onClick={handleSave}>💾 Save</button>
          <button onClick={handleExportPDF}>📄 Export PDF</button>
          <button onClick={handleExportDoc}>📝 Export DOCX</button>
        </div>
      </div>
    </LexicalComposer>
  );
};

export default RichTextEditor;
